
<template>
  <div class="overlay">
    <div class="overlay__inner">
      <div class="panel">
        <div class="panel__header">
          <h3 class="panel__title">Edit Commission Fields</h3>

          <span class="overlay__close" @click="done">
                        <i class="fal fa-times"></i>
                    </span>
        </div>

        <div class="panel__content">
          <div style="margin-bottom: 2rem;">
            <div class="form-field">
              <div class="grid-x grid-padding-x">
                <div class="cell small-4">
                  <label>Key</label>
                </div>
                <div class="cell small-5">
                  <label>Value</label>
                </div>
                <div class="cell shrink">

                </div>
              </div>
            </div>

            <div class="form-field" v-for="(field, i) in fields" :key="i">
              <div class="grid-x grid-padding-x align-middle">
                <div class="cell small-4">
                  <input type="text" name="key" :value="field.key" v-on:input="field.key = $event.target.value">
                </div>
                <div class="cell small-5">
                  <input type="text" name="value" :value="field.value" v-on:input="field.value = $event.target.value">
                </div>
                <div class="cell shrink">
                                    <span @click="removeField(i)" class="remove">
                                        <i class="fa fa-times"/>
                                    </span>
                </div>
              </div>
            </div>
          </div>

          <button class="button--alt" @click="addField">
            <i class="fa fa-plus"></i>
            Add Field
          </button>

          <div class="panel__footer text-right">
            <button class="button--alt" @click="done">Cancel</button>
            <button @click="saveFields">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import client from '@/mixins/client'
import utils from '@/mixins/utils'
import Checkbox from '@/globals/checkbox'

export default {
  components: {Checkbox},
  props: [],
  mixins: [client, utils],
  data: function () {
    return {
      fields: []
    }
  },
  computed: {
    appSettings () {
      return this.$store.state.appSettings
    }
  },
  methods: {
    done () {
      this.$emit('done')
    },
    addField () {
      this.fields.push({
        id: '',
        key: '',
        value: ''
      })
    },
    removeField (index) {
      this.fields.splice(index, 1)
    },
    saveFields () {
      this.request('post', '/vendors/commission-fields/', {
        fields: this.fields
      }).then(response => {
        this.$emit('save')
      })
    }
  },
  created () {
    this.fields = this.appSettings.portal_commission_fields

    console.log(this.fields)

    // this.request(
    //     'get', '/vendors/commission-fields/'
    // ).then(response => {
    //     for (let i = 0; i < response.length; i++) {
    //         this.fields.push({
    //             id: response[i].id,
    //             key: response[i].key,
    //             value: response[i].value
    //         })
    //     }
    // })
  }

}

</script>

<style lang="scss" scoped>
@import "../styles/mixins";
@import "../styles/variables";

.remove {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/globals/editCommissionFields.vue